import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "react-query";
import { useLocation } from "react-router";

import { SUPPORTED_LANGUAGE_CODES } from "@src/config/languages";

export const useSyncLanguageFromUrl = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const queryClient = useQueryClient();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const langParam = searchParams.get("lang")?.toLowerCase();

    if (!langParam) return;

    const matchedLang = SUPPORTED_LANGUAGE_CODES.find(
      (code) => code === langParam || langParam.startsWith(code),
    );

    if (
      matchedLang &&
      i18n.language !== matchedLang &&
      !i18n.language.startsWith(matchedLang)
    ) {
      i18n.changeLanguage(matchedLang).then(() => {
        queryClient.invalidateQueries();
      });
    }
  }, [location.search, i18n, queryClient]);
};
